<div class="login bg-aircontainer">
    <div class="container h-100 scroll-y">
        <div class="login__container row justify-content-center align-items-center py-3">
            <div class="col-12 col-lg-9">
                <div class="login__content d-flex flex-column flex-md-row">
                    <div class="login__brand d-flex flex-row flex-md-column justify-content-between flex-wrap p-3">
                        <div class="login__brand__title text-center mt-md-3">
                            <app-auth-logo></app-auth-logo>
                        </div>
                    </div>
                    <form class="login__form p-3 flex-grow-1 bg-white" [formGroup]="recoveryForm"
                        (ngSubmit)="sendEmail(recoveryForm)" novalidate>
                        <div class="login__form__title mb-4">
                            <h2>Forgot you password?</h2>
                            <small>Don't worry. Just enter the email you registered with us.</small>
                        </div>
                        <div class="form-group">
                            <label for="txt__Email">Email address</label>
                            <input class="form-control" type="email" placeholder="Enter your email"
                                formControlName="usr_email">
                        </div>
                        <div class="form-group">
                            <label>Confirm email</label>
                            <input type="email" class="form-control" placeholder="Confirm email"
                                formControlName="confirm_email">
                        </div>
                        <div class="alert-login danger" [class.invisible]="!alertMessage">
                            <span>{{alertMessage}}</span>
                        </div>


                        <div class="form-group">
                            <button type="submit" class="btn btn-primary mt-3 mb-0"
                                [disabled]="!(recoveryForm.valid) || sending" [class.loading]="sending">
                                Send
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>